import {HttpClient} from "../httpClient/HttpClient";

export class LogsService {
    constructor() {
        this.httpClient = new HttpClient();
    }

    getLogs(fundID, page, size, actionType, category, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/audits`,
                {
                    page: page,
                    size: size,
                    "audit_type": actionType,
                    "action": category,
                    "start_date": startDate,
                    "end_date": endDate
                }
            ).then(resolve).catch(reject)
        })
    }

    getLogDetail(fundID, logId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/audits/${logId}`,
            ).then(resolve).catch(reject)
        })
    }
}